import { render, staticRenderFns } from "./register-new-professional.vue?vue&type=template&id=c019d91a&"
import script from "./register-new-professional.vue?vue&type=script&lang=js&"
export * from "./register-new-professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSpacer,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c019d91a')) {
      api.createRecord('c019d91a', component.options)
    } else {
      api.reload('c019d91a', component.options)
    }
    module.hot.accept("./register-new-professional.vue?vue&type=template&id=c019d91a&", function () {
      api.rerender('c019d91a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/register-new-professional.vue"
export default component.exports